(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["content-card"] && !Shopify.designMode) return;
  try {
    // Flip cards: the "+" on the front and the close on the back turn the card. The face turned away is inert, so
  // focus and screen readers stay on the side on show; focus moves to the other side's button without scrolling,
  // so turning a card never moves a slider it sits in.
  if (!window.contentCardFlipReady) {
    window.contentCardFlipReady = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-card-flip]');
      if (!button) return;
      const card = button.closest('.content-card--flip');
      if (!card) return;
      const front = card.querySelector('.content-card__face--front');
      const back = card.querySelector('.content-card__face--back');
      const opener = front.querySelector('[data-card-flip]');
      const flipped = card.classList.toggle('content-card--flipped');
      opener.setAttribute('aria-expanded', String(flipped));
      front.toggleAttribute('inert', flipped);
      back.toggleAttribute('inert', !flipped);
      const target = flipped ? back.querySelector('[data-card-flip]') : opener;
      if (target) target.focus({ preventScroll: true });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-restore"] && !Shopify.designMode) return;
  try {
    (() => {
    const key = 'scroll-restore:' + location.pathname + location.search;
    const store = (() => {
      try {
        return window.sessionStorage;
      } catch (e) {
        return null;
      }
    })();
    if (!store) return;

    window.addEventListener('pagehide', () => {
      try {
        store.setItem(key, String(Math.round(window.scrollY)));
      } catch (e) {}
    });

    const navigation = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (!navigation || navigation.type !== 'back_forward' || location.hash) return;

    let saved = 0;
    try {
      saved = parseInt(store.getItem(key) || '0', 10);
    } catch (e) {}
    if (!(saved > 0)) return;

    // Once the page has laid out (images and sliders change its height), and only if the browser left it near the
    // top; a visitor who has already scrolled is not moved.
    const restore = () => {
      if (window.scrollY < 50) window.scrollTo(0, saved);
    };
    if (document.readyState === 'complete') {
      requestAnimationFrame(restore);
    } else {
      window.addEventListener('load', () => requestAnimationFrame(restore), { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
